import { useMemo } from 'react';
/**
 * 获取全局（`:root`）指定 CSS 变量的值
 */

export function useCssVar(prop) {
  return useMemo(function () {
    return window.getComputedStyle(document.documentElement).getPropertyValue(prop);
  }, [prop]);
}